import { useCartDrawer } from "../cartDrawer/context";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setComponentActive, setSearch } from "../../reducers/userConfigSlice";
import { LuUser, LuSearch, LuShoppingBag, LuArrowLeft, LuChevronDown } from "react-icons/lu";
import { BrandImage } from "../brandImage";
import { applyShopBranding } from "../../hooks/shopBranding";
import { useShopLogout } from "../../hooks/useShopLogout";
import "./style.css";

export const HeaderMobile = ({ account = false }) => {
  const { openCart } = useCartDrawer();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { logOff, loggingOut } = useShopLogout();
  const info = useSelector(state => state.aplicationConfig.corporationData.info);
  const { logged, userData, search, cart } = useSelector(state => state.aplicationConfig.userConfig);
  const [accountOpen, setAccountOpen] = useState(false);
  const name = info?.corporation?.name || "Tienda";
  const count = (cart?.ShoppingCartProducts || []).reduce((sum, line) => sum + Number(line.quantity || 0), 0);
  const accountTitle = ({ "/details": "Mis datos", "/history": "Mis pedidos", "/delivery-options": "Direcciones", "/invoice-options": "Facturación", "/policies": "Privacidad" })[pathname] || "Seguimiento";
  const catalogue = pathname === "/" || pathname.startsWith("/products");
  useEffect(() => applyShopBranding({name, favIcon: info?.favIcon, logo: info?.logo}), [name, info?.favIcon, info?.logo]);
  useEffect(() => { setAccountOpen(false); }, [pathname]);
  const go = path => {
    setAccountOpen(false);
    dispatch(setComponentActive(path.replace(/^\//, "")));
    navigate(path);
  };
  return (
    <header className="shopHeader eats-header">
      <div className={`eats-header-inner ${account ? "eats-account-header" : ""}`}>
        <button type="button" className="eats-brand" aria-label="Ir a la tienda" onClick={() => go("/")}>
          {account ? <><LuArrowLeft aria-hidden="true" /><span>Volver a la tienda</span></> : <><BrandImage src={info?.logo} className="brand" /><span>{name}</span></>}
        </button>
        {account && <><strong className="eats-account-title">Mi cuenta</strong><button type="button" className="eats-account-mobile-title" aria-label="Secciones de mi cuenta" aria-expanded={accountOpen} onClick={() => setAccountOpen(value => !value)}>{accountTitle}<LuChevronDown aria-hidden="true" /></button></>}
        {catalogue && <label className="eats-search">
          <LuSearch aria-hidden="true" />
          <input type="search" placeholder="Buscar productos…" aria-label="Buscar productos" value={search || ""}
            onChange={event => dispatch(setSearch(event.target.value))} />
        </label>}
        <div className="eats-header-actions">
          {!account && <button type="button" className="eats-icon-button" aria-label="Cuenta" aria-expanded={logged ? accountOpen : undefined}
            onClick={() => logged ? setAccountOpen(value => !value) : go("/login")}>
            <LuUser aria-hidden="true" />
          </button>}
          <button type="button" className="eats-icon-button" aria-label={`Carrito${count ? `, ${count} artículos` : ""}`} onClick={openCart}>
            <LuShoppingBag aria-hidden="true" />{count > 0 && <span className="eats-cart-count">{count}</span>}
          </button>
        </div>
        {accountOpen && <nav className="eats-account-menu" aria-label="Mi cuenta">
          <strong>{userData?.fullname || "Mi cuenta"}</strong>
          {[["/details", "Detalles de mi cuenta"], ["/history", "Historial de pedidos"], ["/delivery-options", "Direcciones de envío"], ["/invoice-options", "Direcciones de facturación"], ["/policies", "Políticas de privacidad"]].map(([path, label]) =>
            <button type="button" key={path} onClick={() => go(path)}>{label}</button>)}
          <button type="button" disabled={loggingOut} onClick={() => { setAccountOpen(false); logOff(); }}>{loggingOut ? "Cerrando sesión…" : "Salir"}</button>
          <button type="button" onClick={() => setAccountOpen(false)}>Cerrar menú</button>
        </nav>}
      </div>
    </header>
  );
};
